import linkDao from '../../../../dao/smbpartner/linkDao';

const CREATE_LINK = 'pages/partner/linkbuilder/link/CREATE_LINK';
const CREATE_LINK_SUCCESS =
  'pages/partner/linkbuilder/link/CREATE_LINK_SUCCESS';

const initialState = {
  utm: {
    source: '',
    medium: '',
    campaign: '',
    content: '',
  },
  generatedReferral: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_LINK:
      return {
        ...state,
      };
    case CREATE_LINK_SUCCESS:
      return {
        ...state,
        generatedReferral: {...action.json},
      };
    default:
      return {
        ...state,
      };
  }
};

export function createLink(referralLink) {
  return dispatch => {
    dispatch({type: CREATE_LINK});
    return linkDao.createLink(referralLink).then(json => {
      dispatch({type: CREATE_LINK_SUCCESS, json});
      return json;
    });
  };
}
